import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
} from "@mui/material";

// Tab 3: Quantity & Packaging
const QuantityPackagingTab = ({
  requestedQuantity,
  setRequestedQuantity,
  productPackaging,
  setProductPackaging,
  packageSize,
  setPackageSize,
  additionalPackagingNotes,
  setAdditionalPackagingNotes,
  packagingMaster,
  filteredPackageSizes,
  loadPackageSizes,
  errors,
  isViewMode,
}) => {
  // Get unique packaging subtypes for the first dropdown
  const uniquePackagingTypes = [
    ...new Set(packagingMaster.map((item) => item.Subtype).filter(Boolean)),
  ];

  const handlePackagingChange = (e) => {
    if (!isViewMode) {
      const selectedPackaging = e.target.value;
      setProductPackaging(selectedPackaging);
      setPackageSize(""); // Reset package size when packaging type changes
      loadPackageSizes(selectedPackaging);
    }
  };

  const handlePackageSizeChange = (e) => {
    if (!isViewMode) {
      setPackageSize(e.target.value);
    }
  };

  return (
    <div className="row g-3">
      <div className="col-md-4">
        <Typography variant="body2">Requested Quantity (MT) *</Typography>
        <TextField
          type="number"
          step="any"
          value={requestedQuantity}
          onChange={(e) => !isViewMode && setRequestedQuantity(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          placeholder="Enter quantity in metric tons"
          error={!!errors.requestedQuantity}
          helperText={errors.requestedQuantity}
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-4">
        <Typography variant="body2">Product Packaging</Typography>
        <FormControl sx={{ backgroundColor: "white", width: "100%" }}>
          {isViewMode ? (
            <TextField
              value={productPackaging}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No productPackaging selected"
            />
          ) : (
            <Select
              value={productPackaging}
              onChange={handlePackagingChange}
              displayEmpty
              disabled={isViewMode}
            >
              <MenuItem value="">Select packaging type</MenuItem>
              {uniquePackagingTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-4">
        <Typography variant="body2">Package Size</Typography>
        <FormControl sx={{ backgroundColor: "white", width: "100%" }}>
          {isViewMode ? (
            <TextField
              value={packageSize}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No packageSize selected"
            />
          ) : (
            <Select
              value={packageSize}
              onChange={handlePackageSizeChange}
              displayEmpty
              disabled={isViewMode || !productPackaging}
            >
              <MenuItem value="">Select package size</MenuItem>
              {filteredPackageSizes.map((item) => (
                <MenuItem key={item.Value} value={item.Value}>
                  {item.Value}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-12">
        <Typography variant="body2">Additional Packaging Notes</Typography>
        <TextareaAutosize
          value={additionalPackagingNotes}
          onChange={(e) =>
            !isViewMode && setAdditionalPackagingNotes(e.target.value)
          }
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter additional packaging requirements or notes"
          disabled={isViewMode}
        />
      </div>
    </div>
  );
};
export default QuantityPackagingTab;
